import { MILITAO_URL } from '@/config'

export const isOnboarding = (searchParams: URLSearchParams) => {
  return !!searchParams.get('priceId')
}

export const getCreateAccountPath = (searchParams: URLSearchParams) => {
  const path = '/create-account'
  if (!searchParams) return path
  return `${path}?${searchParams.toString()}`
}

export const getWelcomeUrl = () => {
  return `${MILITAO_URL}/welcome`
}

export const getCreateAccountUrl = (searchParams: URLSearchParams) => {
  return `${MILITAO_URL}${getCreateAccountPath(searchParams)}`
}
